import { eType, Section } from "../Section";
import { GameWorld, eGameObject as eWorldObject } from "../../GameWorld";

export class SafeArea_2 extends Section {
    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        super("safeArea_2", eType.safeArea_2, false);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected addObjectEntities(): void {
        let world = GameWorld.instance;

        // Zem
        let e = world.getObjectNewEntity(eWorldObject.road);
        e.setLocalPosition(0, 0, 0);
        e.setLocalScale(1, 1, 0.5);
        e.reparent(this._root);

        // Kuzele
        e = world.getObjectNewEntity(eWorldObject.cone);
        e.setLocalPosition(-1, 0, 0.08);
        e.setLocalEulerAngles(0, 0, 0);
        e.reparent(this._root);

        e = world.getObjectNewEntity(eWorldObject.cone);
        e.setLocalPosition(-0.7, 0, -0.08);
        e.setLocalEulerAngles(0, 0, 0);
        e.reparent(this._root);

        e = world.getObjectNewEntity(eWorldObject.cone);
        e.setLocalPosition(0.7, 0, 0.08);
        e.setLocalEulerAngles(0, 0, 0);
        e.reparent(this._root);

        e = world.getObjectNewEntity(eWorldObject.cone);
        e.setLocalPosition(1, 0.092, -0.08);
        e.setLocalEulerAngles(180, 0, 65);
        e.reparent(this._root);
    }
}